import {IsDefined, IsIn} from 'class-validator';
import {CallCenterAgentStatus} from '@/classes/dto/api-handler/response/placetel/api/CallCenterAgent.placetel.response.dto';

/** Status, die ein Nutzer für seinen eigenen Agent setzen darf */
export type UserSettableCallCenterAgentStatus = Extract<CallCenterAgentStatus, 'online' | 'pause'>;

export const USER_SETTABLE_CALL_CENTER_AGENT_STATUSES: UserSettableCallCenterAgentStatus[] = ['online', 'pause'];

export class SetCallCenterAgentStatusPlacetelRequestDto {
    @IsDefined()
    @IsIn(USER_SETTABLE_CALL_CENTER_AGENT_STATUSES)
    status: UserSettableCallCenterAgentStatus;
}
